import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import DefaultModal from 'components/Modal/DefaultModal';
import { Row, Col, InputGroup, Input, InputGroupAddon } from 'reactstrap';
import ChatBroadcastListSMSService from '../../../../../../../ChatBroadcastListSMS/service';
import ReactButton from 'components/Buttons/ReactButton';
import ReactLoader from 'components/Loader';
import { TableContainer } from './style';
import Pagination from 'components/Pagination';
import { toast } from 'react-toastify';
import useDebounce from './hooks/useDebaunce';
import { isNaN } from 'lodash';
import ListMultiCampaignsTable from './components/multiCampaignTable';

import { RiUserSearchLine } from 'react-icons/ri';
import { useSelector } from 'react-redux';
import { IoSearch } from 'react-icons/io5';

import FlexChatIntegration from 'views/ServicePanel/components/QueueContent/components/Contact/service/FlexChatIntegration';
import BroadcastListSMSService from '../../../../../../../../views/ChatBroadcastListSMS/service/index';
import DialerService from '../../../../../../../Dialer/service';

const ListBroadcastListModal = ({
  show,
  onModalToggle,
  contacts,
  campaignType,
  ...props
}) => {
  const [chatBroadcastList, setChatBroadcastList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isClientSearchModalOpen, setIsClientSearchModalOpen] = useState(false);
  const [redirect, setRedirect] = useState(null);

  const [page, setPage] = useState(1);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);

  const [filterByName, setFilterByName] = useState('');
  const [filterByTelephone, setFilterByTelephone] = useState('');
  const [filterByEmail, setFilterByEmail] = useState('');

  const [searchValue, setSearchValue] = useState('');

  const [filteredHistory, setFilteredHistory] = useState([]);
  const dropdownRef = useRef(null);

  const debouncedSearchValue = useDebounce(searchValue, 1000);

  const [searchHistory, setSearchHistory] = useState(() => {
    const savedHistory = localStorage.getItem('searchHistory');
    return savedHistory ? JSON.parse(savedHistory) : [];
  });

  useEffect(() => {
    if (debouncedSearchValue.trim() !== '') {
      setSearchHistory((prevHistory) => {
        const newHistory = prevHistory.filter(
          (item) => item !== debouncedSearchValue
        );
        return [debouncedSearchValue, ...newHistory].slice(0, 10);
      });
    }
  }, [debouncedSearchValue]);

  useEffect(() => {}, []);

  useEffect(() => {
    localStorage.setItem('searchHistory', JSON.stringify(searchHistory));
  }, [searchHistory]);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const searchContainerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (searchValue.length === 0 || !searchValue.length) {
      setPage(1);
      setFilterByName('');
      setFilterByTelephone('');
      setFilterByEmail('');
      return;
    }

    const defaultFieldNames = ['nome', 'telefone', 'email'];
    const textFilter = [...defaultFieldNames].map((fieldName) => ({
      [fieldName]: searchValue
    }));
    const fieldsToFilter = [...textFilter];

    const filters = {};
    fieldsToFilter.forEach((filter) => {
      Object.assign(filters, filter);
    });

    const filtersDTO = {};
    const filtersDTOAllContacts = {};
    for (const key in filters) {
      const value = filters[key];
      if (value) {
        filtersDTO[key] = value;
        filtersDTOAllContacts[key] = value;
      }
    }
    const isNotANumber = isNaN(parseInt(filtersDTOAllContacts.telefone));

    if (isNotANumber) {
      filtersDTOAllContacts.telefone = '';
    } else {
      filtersDTOAllContacts.nome = '';
    }
  }, [debouncedSearchValue]);

  useEffect(() => {
    async function goToFistPage() {
      setActivePage(1);
    }
    goToFistPage();
  }, [filterByName, filterByTelephone, filterByEmail, debouncedSearchValue]);

  useEffect(() => {
    setLoading(true);
    handleGetChatBroadcastList();
  }, [
    page,
    activePage,
    filterByName,
    filterByTelephone,
    filterByEmail,
    isClientSearchModalOpen,
    show,
    contacts
  ]);

  useEffect(() => {
    setFilterByTelephone('');
    setFilterByName('');
    setSearchValue('');
    setFilterByEmail('');
  }, [show]);

  useEffect(() => {
    if (searchValue.trim() === '') {
      setFilteredHistory(searchHistory);
    } else {
      const filtered = searchHistory.filter((item) =>
        item.toLowerCase().startsWith(searchValue.toLowerCase())
      );
      setFilteredHistory(filtered);
    }
  }, [searchValue, searchHistory]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  const [buttonSearchHover, setButtonSearchHover] = useState(false);

  const handleGetChatBroadcastList = useCallback(
    (selectedPage = 1) => {
      setLoading(true);

      let fetchData;
      if (campaignType === 'whatsapp') {
        fetchData =
          FlexChatIntegration.getBroadcastListPagination(selectedPage);
      } else if (campaignType === 'sms') {
        fetchData = BroadcastListSMSService.getAllPagination(selectedPage);
      } else if (campaignType === 'discador') {
        fetchData = DialerService.getAll(selectedPage);
      } else {
        console.warn('Tipo de campanha não suportado:', campaignType);
        setLoading(false);
        return;
      }

      fetchData
        .then((res) => {
          let data, quantity;

          if (campaignType === 'discador') {
            data = res.data.data;
            quantity = res.data.totalRegisters;
          } else {
            data = res.data.registers;
            quantity = res.data.count;
          }

          if (quantity) {
            setChatBroadcastList([...data]);
            setQuantity(quantity);
          }
        })
        .catch((error) => {
          const errorMessage =
            error.response &&
            error.response.data &&
            error.response.data.message;
          toast.error(errorMessage || 'Erro ao listar campanhas');
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [campaignType]
  );

  useEffect(() => {
    handleGetChatBroadcastList();
  }, [handleGetChatBroadcastList]);

  const handlePageChange = (page) => {
    setActivePage(page);
    handleGetChatBroadcastList(page);
  };

  const handleGetChatBroadcastListFiltered = useCallback(
    (selectedPage = 1) => {
      setLoading(true);
      if (debouncedSearchValue === '') {
        handleGetChatBroadcastList();
        return;
      }
      ChatBroadcastListSMSService.getAllSearch(
        selectedPage,
        10,
        debouncedSearchValue
      )
        .then((res) => {
          const data = res.data.registers;
          const quantity = res.data.count;
          if (quantity) {
            setChatBroadcastList([...data]);
            setQuantity(quantity);
          }
        })
        .catch((error) => {
          const errorMessage =
            error.response &&
            error.response.data &&
            error.response.data.message;
          toast.error(errorMessage || 'Erro ao listar listas de transmissão');
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [debouncedSearchValue, handleGetChatBroadcastList]
  );

  useEffect(() => {
    handleGetChatBroadcastListFiltered();
  }, [handleGetChatBroadcastListFiltered]);

  const handleCreateClick = () => {
    if (campaignType === 'whatsapp') {
      setRedirect({
        pathname: '/admin/chat/broadcast-list/form',
        state: { contacts }
      });
    } else if (campaignType === 'sms') {
      setRedirect({
        pathname: '/admin/chat/broadcast-list-sms/form',
        state: { contacts }
      });
    } else if (campaignType === 'discador') {
      setRedirect({
        pathname: '/admin/dialer/form',
        state: { contacts }
      });
    }
  };

  if (redirect) {
    return <Redirect to={redirect} />;
  }

  return (
    <DefaultModal
      show={show}
      onModalToggle={onModalToggle}
      campaignType={campaignType}
      title={`Selecionar lista de transmissão ${
        campaignType === 'whatsapp'
          ? 'whatsApp'
          : campaignType === 'sms'
          ? 'sms'
          : campaignType === 'discador'
          ? 'discador'
          : 'Desconhecido'
      }`}
      subtitle={`${
        campaignType === 'discador' ? 'Campanhas' : 'Listas de transmissão'
      }: ${quantity}`}
      showCloseButton={false}
      modalContainerClasses="modal-lg"
      {...props}
    >
      <Row>
        <Col>
          <div style={{ position: 'relative' }} ref={dropdownRef}>
            <InputGroup
              style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              <Input
                bsSize="md"
                placeholder={`Buscar ${
                  campaignType === 'discador'
                    ? 'campanhas'
                    : 'listas de transmissão'
                }...`}
                type="text"
                value={searchValue}
                onChange={(event) => {
                  setSearchValue(event.target.value);
                  setDropdownOpen(event.target.value.trim() !== '');
                }}
                onClick={() => setDropdownOpen(true)}
                onFocus={() => setDropdownOpen(true)}
                style={{
                  padding: '1rem 3rem 1rem 1rem',
                  border: '0.05rem solid lightgray',
                  borderRadius: '10px',
                  fontSize: '0.9rem',
                  width: '100%',
                  outline: 'none',
                  transition: 'box-shadow 0.3s ease',
                  color: '#33333380',
                  fontWeight: '500'
                }}
              />
              <div
                style={{
                  backgroundColor: systemConfiguration.primary_color || 'gray',
                  borderRadius: '0.5rem',
                  padding: '0.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '32px',
                  width: '32px',
                  right: '5.35rem',
                  cursor: 'pointer',
                  transition: 'opacity 0.3s ease',
                  marginLeft: '-3rem',
                  zIndex: 3,
                  opacity: buttonSearchHover ? 1 : 0.8
                }}
                onMouseEnter={() => setButtonSearchHover(true)}
                onMouseLeave={() => setButtonSearchHover(false)}
              >
                <IoSearch size={20} color="#fff" />
              </div>

              <InputGroupAddon addonType="append">
                <ReactButton
                  onClick={handleCreateClick}
                  btnColor="primary"
                  style={{
                    background: systemConfiguration.primary_color,
                    color: '#fff',
                    borderRadius: '5px',
                    border: 'none',
                    height: '45px',
                    marginLeft: '1rem'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px'
                    }}
                  >
                    <RiUserSearchLine size={16} />
                    Criar lista de transmissão
                  </div>
                </ReactButton>
              </InputGroupAddon>
            </InputGroup>

            {filteredHistory.length > 0 && dropdownOpen && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  backgroundColor: '#fff',
                  borderRadius: '4px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  zIndex: 1000,
                  maxHeight: '200px',
                  overflowY: 'auto',
                  marginLeft: '1rem'
                }}
              >
                {filteredHistory.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      setSearchValue(item);
                      setDropdownOpen(false);
                    }}
                    style={{
                      padding: '10px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #eee'
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = '#f5f5f5')
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = '#fff')
                    }
                  >
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
        </Col>
      </Row>

      <TableContainer style={{ overflowX: 'auto' }}>
        {loading ? (
          <Row className="justify-content-md-center py-3">
            <ReactLoader />
          </Row>
        ) : (
          <ListMultiCampaignsTable
            chatBroadcastList={chatBroadcastList}
            campaignType={campaignType}
            contacts={contacts}
            page={activePage}
          />
        )}
        <Pagination
          activePage={activePage}
          totalItemsCount={quantity}
          onChange={handlePageChange.bind(this)}
        />
      </TableContainer>
    </DefaultModal>
  );
};

export default ListBroadcastListModal;
